import { render, staticRenderFns } from "./schoolinfoadd.vue?vue&type=template&id=47a68b80&scoped=true"
import script from "./schoolinfoadd.vue?vue&type=script&lang=js"
export * from "./schoolinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a68b80",
  null
  
)

export default component.exports